export enum Ticker {
  BTC = 'BTC',
  ETH = 'ETH',
}
